import modalMixin from '../../../mixins/_modal';
import imagesConfigMixin from '../../../mixins/_images_config';

/**
 * パーツ編集ベースコンポーネント
 */
export default {
    name: 'addImagesConfig',
    template: '#add_images_config',
    data() {
        return {
            // 選択状態保持変数
            images_select_status: {},
        };
    },
    props: {
        // 商品画像・詳細画像
        prop_lib_images_config: {
            type: Object,
            default: () => ({}),
            required: false,
        },
        // 編集ID(主に画像参照に使う)
        edit_id: {
            type: [String, Number],
            default: '',
            require: false
        },
    },
    mixins: [
        modalMixin
    ],
    components: {
        // 画像選択コンポーネント
        'image-check-box': {
            template: '#add_images_config_image_check_box',
            data() {
                return {
                    page_dir: 'item',
                };
            },
            props: {
                // 指定の画像ファイル名
                image: {
                    type: String,
                    required: true,
                },
                // 保存する画像の接頭語
                edit_id_dir: {
                    type: [String, Number],
                    required: false,
                    default: null
                },
                // 選択状態
                prop_selected: {
                    type: Boolean,
                    required: false,
                    default: false,
                },
                // 表示タイプ(連番を左上に表示するか) single|multi
                type: {
                    type: String,
                    required: false,
                    default: 'single',
                    validator: function (value) {
                        return ['single', 'multi'].indexOf(value) !== -1;
                    }
                },
            },
            mixins: [
                imagesConfigMixin,
            ],
            computed: {
                // 選択状態
                selected: {
                    get() {
                        return this.prop_selected;
                    },
                    set(value) {
                        this.$emit('update:prop_selected', value);
                    },
                },
            },
            methods: {
                // 画像クリック時コールバック
                onSelectStatusChange: function() {
                    this.selected = !this.selected;
                },
            },
            emits: [
                'update:prop_selected'  // selected setterで使用
            ],
        },
        // 確認ダイアログ
        'modal-add-images-config-confirm': {
            template: '#modal_add_images_config_confirm',
            data() {
                return {
                    // 既存パーツを残すかどうか
                    is_take_over: true
                };
            },
            mixins: [
                modalMixin,
            ],
            methods: {
                // ダイアログ表示処理
                show: function () {
                    // 選択状態の初期化
                    this.is_take_over = true;
                    this.open();
                },
                // 「テンプレートの内容で更新する」押下時
                emitAddImagesConfigConfirm: function(){
                    this.$emit('add-images-config-confirm', this.is_take_over);
                    this.close();
                },
            },
            emits: [
                'add-images-config-confirm'  // emitAddImagesConfigConfirm()で使用
            ],
        },
    },
    computed: {
        // プレビュー表示用にパスを整えてから使用する
        imagesSelectStatus: function () {
            // 空の場合作成する
            if (!this.images_select_status || Object.keys(this.images_select_status).length <= 0) this.initStatus();
            return this.images_select_status;
        },
        selectedImages: function () {
            const status = this.imagesSelectStatus;
            return status.lib_images_config.reduce(
                (arr, data) => (data && data['selected'] === true ? [ ...arr, data['image_config'] ] : arr),
                (status.image_config.selected === true ? [ status.image_config.image_config ] : [])
            );
        },
    },
    emits: [
        'add-parts-data-arr'  // emitUpdatValue()で使用
    ],
    methods: {
        // ダイアログ表示処理
        show: function () {
            // 選択状態の初期化
            this.initStatus();
            this.open();
        },
        // 選択状態の初期化処理
        initStatus: function () {
            this.images_select_status = {
                image_config: { selected: true, image_config: this.prop_lib_images_config.image_config },
                lib_images_config: this.prop_lib_images_config.lib_images_config.map(function(image_config) { return { selected: true, image_config }; }),
            };
        },
        // 選択を全て外す
        removeAll: function () {
            this.images_select_status = {
                image_config: { selected: false, image_config: this.prop_lib_images_config.image_config },
                lib_images_config: this.prop_lib_images_config.lib_images_config.map(function(image_config) { return { selected: false, image_config }; }),
            };
        },

        // 設定データの更新
        update: function (event) {
            // バリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();
            this.$refs.modalAddImagesConfigConfirm.show();
        },

        /**
         * 確認ダイアログコールバック
         *
         * 選択された画像配列から画像パーツを作成して追加する
         * * 画像パーツテンプレートの一番上をベースに作成する
         *
         * @param {Boolean} is_take_over true: 残す, false: 残さない
         * @returns
         */
        updateConfirm: async function (is_take_over) {
            // パーツ選択コンポーネントからパーツデータを取得
            const parts_all_data = await this.$parent.$refs.parts_selecter.getPartsData();
            // パーツデータを取得できなかった場合は通信エラーが出ているため何もせずダイアログを閉じる
            if (!parts_all_data || Object.keys(parts_all_data).length <= 0 || !parts_all_data.image?.data || !parts_all_data.image.data[0]) {
                this.close();
                return;
            }

            // テンプレートからパーツデータを作成して追加する
            const template = parts_all_data.image.data[0];
            const parts_data = this.selectedImages.map((path) => {
                let data = JSON.parse(JSON.stringify(template));
                data.data.main[0].image = path;
                return data;
            });
            this.emitUpdatValue(parts_data, is_take_over);
            this.close();
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集内容で更新
        emitUpdatValue: function (parts_data, is_take_over) {
            this.$emit('add-parts-data-arr', parts_data, is_take_over);
        }

    }
};
